import React from "react";
import Input from "../../../../widget/common/form/Input";
import PhoneNumber from "../../../../widget/common/form/PhoneNumber";
import { GuestUserFormContextImport } from "../../../../provider/home_guest_user/guest_user_form/GuestUserFormContextProvider";
import TextArea from "../../../../widget/common/form/Textarea";
import AppTranslation from "../../../../service/app_translation/AppTranslation";

export const GuestUserFormNameField = () => {
  const { nameField, fieldsValid, submitForm, handleOnChange } =
    GuestUserFormContextImport();

  return (
    <Input
      type="text"
      name="name"
      label="name"
      handleOnChange={handleOnChange}
      value={nameField}
      validate={true}
      error={submitForm ? !fieldsValid.name : false}
    />
  );
};

export const GuestUserFormEmailField = () => {
  const { emailField, handleOnChange } = GuestUserFormContextImport();

  return (
    <Input
      type="email"
      name="email"
      label="email"
      handleOnChange={handleOnChange}
      value={emailField}
      validate={false}
      //error={submitForm ? !fieldsValid.email : false}
    />
  );
};

export const GuestUserFormPhoneField = () => {
  const { phoneField, phoneCodeField, handleOnChange, applyCountryCode } =
    GuestUserFormContextImport();

  return (
    <PhoneNumber
      name="phone_number"
      label="phone_number"
      handleOnChange={handleOnChange}
      value={phoneField}
      code={phoneCodeField}
      validate={false}
      callback={applyCountryCode}
      // error={submitForm ? !fieldsValid.phone : false}
    />
  );
};

export const GuestUserFormDateField = () => {
  const { dateField, fieldsValid, submitForm, handleOnChange } =
    GuestUserFormContextImport();

  return (
    <Input
      type="datepicker"
      name="date"
      label="date"
      handleOnChange={handleOnChange}
      value={dateField}
      validate={true}
      error={submitForm ? !fieldsValid.date : false}
    />
  );
};

export const GuestUserFormTimeField = () => {
  const { timeField, fieldsValid, submitForm, handleOnChange } =
    GuestUserFormContextImport();

  return (
    <Input
      type="timepicker"
      name="time"
      label="time"
      handleOnChange={handleOnChange}
      value={timeField}
      validate={true}
      error={submitForm ? !fieldsValid.time : false}
    />
  );
};

export const GuestUserFormSubjectField = () => {
  const { subjectField, fieldsValid, submitForm, handleOnChange } =
    GuestUserFormContextImport();

  return (
    <Input
      type="text"
      name="subject"
      label="subject"
      handleOnChange={handleOnChange}
      value={subjectField}
      validate={true}
      error={submitForm ? !fieldsValid.subject : false}
    />
  );
};

export const GuestUserFormMessageField = () => {
  const { messageField, fieldsValid, submitForm, handleOnChange, maxWords } =
    GuestUserFormContextImport();

  return (
    <TextArea
      name="message"
      rowSize={6}
      placeHolder={AppTranslation.text("type_here_max_200_chars")}
      handleOnChange={handleOnChange}
      maxWords={maxWords}
      value={messageField}
      validate={true}
      error={submitForm ? !fieldsValid.message : false}
    />
  );
};
